import axios from "axios";
import API_BASE_URL from "../config"; // Import API URL

const POLLS_API = `${API_BASE_URL}/polls`;

// Fetch Polls (Paged, 5 Records)
export const getPolls = async () => {
  try {
    const response = await axios.post(`${POLLS_API}/paged`, {
      pageNumber: 1,
      pageSize: 5,
      filterText: "",
    });
    return response.data;
  } catch (error) {
    console.error("Get Polls Error:", error);
    return { totalRecords: 0, data: [] };
  }
};

// Submit Vote
export const submitVote = async (pollId, pollOptionId) => {
  try {
    let voterId = localStorage.getItem("voterIdentifier");

    if (!voterId) {
      voterId = `voter-${crypto.randomUUID()}`;
      localStorage.setItem("voterIdentifier", voterId);
    }

    const response = await axios.post(`${POLLS_API}/vote`, {
      PollId: pollId,
      PollOptionId: pollOptionId,
      VoterIdentifier: voterId,
    });

    return response.data;
  } catch (error) {
    console.error("Vote Submission Error:", error);
    return { success: false, message: error.response?.data?.message || "Voting failed." };
  }
};
